function splitString(input) {
  // Find the position of the last hyphen
  let lastHyphenIndex = input.lastIndexOf("-");
  if (lastHyphenIndex === -1) {
    return { field: input, value: "" };
  }

  // Extract the field and value
  let field = input.substring(0, lastHyphenIndex);
  let value = input.substring(lastHyphenIndex + 1);

  // Remove double quotes at the beginning and end of the value, if present
  // eslint-disable-next-line
  value = value.replace(/^\"+|\"+$/g, "");
  value = value.replaceAll("_", "-");
  return { field, value };
}
export function formatWaMessageToPreview(replyMessage, teamSchema) {
  const previewData = {
    caption: replyMessage.caption || "",
    content: replyMessage.content || "",
    role: "assistant",
    id: replyMessage.id,
    type: "text",
    action_button: "",
    items: [],
    products: [],
    actions: [],
    is_final_message: replyMessage.is_final_message || false,
  };

  if (previewData.caption) previewData.header_type = "text";

  if (replyMessage.list_options) {
    // const previewData = {
    //   ...replyMessage,
    //   role: "assistant",
    //   products: [],
    //   actions: [],
    // };
    // previewData = { ...previewData, replyMessage };
    previewData.action_button = replyMessage.action_button;
    previewData.main_menu = true;
    previewData.listTitle = replyMessage.list_title;
    previewData.items = [...replyMessage.list_options];
    delete previewData.list_options;
    // state.appId = replyMessage.app_id;
  }

  if (replyMessage.buttons) {
    previewData.type = "actions";
  } else if (replyMessage.list_options || replyMessage.sections) {
    previewData.type = "menu";
  }

  if (replyMessage.buttons) {
    const actions = [];
    for (const button of replyMessage.buttons) {
      const newButton = { type: button.type, ...button.reply };
      // obtener trigger
      const trigger = button.reply?.trigger ?? "";
      const { field, value } = splitString(trigger);
      newButton.actionTrigger = field;
      newButton.subActionTrigger = value;
      actions.push(newButton);
    }

    previewData.actions = actions;
    previewData.header_type = replyMessage.header_type;
    previewData.header_media_id = replyMessage.header_media_id;
    previewData.header_media_url = replyMessage.header_media_url;
    previewData.header_media_name = replyMessage.header_media_name;
  }

  if (["image", "document"].includes(replyMessage.type)) {
    previewData.type = "file";
    previewData.header_type = replyMessage.type;
    previewData.header_media_id = replyMessage.header_media_id;
    previewData.header_media_url = replyMessage.header_media_url;
    previewData.header_media_name = replyMessage.header_media_name;
    previewData.caption = replyMessage.caption;
  }

  if (replyMessage.schema && !replyMessage.products_id) {
    previewData.type = "form";
    previewData.content = replyMessage.text_initial;
    const result = teamSchema.filter((teamItem) =>
      replyMessage.schema.find((searchItem) => searchItem.id === teamItem.id),
    );
    previewData.schema = result;
  }
  // es de producto
  if (replyMessage.schema && replyMessage.sub_type == "products") {
    previewData.type = "products";
    previewData.content = replyMessage.text_initial;
    previewData.products = replyMessage.products_id;
    // const result = teamSchema.filter((teamItem) =>
    //   replyMessage.schema.find((searchItem) => searchItem.id === teamItem.id),
    // );
    // previewData.schema = result;
  }
  if (replyMessage.schema && replyMessage.sub_type == "order") {
    previewData.type = "order";
    previewData.content = replyMessage.text_initial;
    previewData.products = replyMessage.products_id;
    // const result = teamSchema.filter((teamItem) =>
    //   replyMessage.schema.find((searchItem) => searchItem.id === teamItem.id),
    // );
    // previewData.schema = result;
  }
  if (replyMessage.schema && replyMessage.sub_type == "catalog") {
    previewData.type = "catalog";
    previewData.content = replyMessage.text_initial;
    previewData.products = replyMessage.products_id;
    previewData.header_type = replyMessage.header_type;
    previewData.header_media_id = replyMessage.header_media_id;
    previewData.header_media_name = replyMessage.header_media_name;
    previewData.header_media_url = replyMessage.header_media_url;
    previewData.categories = replyMessage.categories_id || [];
  }

  return previewData;
}

// const uniqueId = new Date();
export function formatWaMessageOnSave(getCurrentStep) {
  console.log("before save", getCurrentStep.parent);
  const responseData = {
    id: getCurrentStep.id,
    parent_id: getCurrentStep.parent?.id,
    parent_type: getCurrentStep.parent?.override_type || getCurrentStep.parent?.type,
    button_ind: getCurrentStep.parent?.index,
  };
  const schema = { ...getCurrentStep };
  if (schema.type == "menu" && schema.main_menu) {
    const rows = [];
    for (const opt of schema.items) {
      rows.push({ id: opt.id || "", title: opt.title });
    }
    schema.list_title = schema.listTitle;
    schema.list_options = rows;
    // schema.action_button = schema.action_button;
    schema.type = "menu";
    delete schema.items;
    delete schema.actions;
    responseData.reply_message = schema;
    responseData.type = "reply_message";
  }

  if (schema.type == "actions") {
    const buttons = [];
    for (const btn of schema.actions) {
      const button = {
        type: "reply",
        reply: {
          trigger: btn.trigger,
          id: btn.id,
          title: btn.title,
        },
      };
      buttons.push(button);
    }
    schema.buttons = buttons;
    schema.type = "interactive";
    delete schema.items;
    delete schema.menu_title;
    delete schema.action_button;
    delete schema.trigger;
    delete schema.actionTrigger;
    delete schema.subActionTrigger;
    responseData.reply_message = schema;
    responseData.type = "reply_message";
    responseData.header_type = schema.header_type;
    responseData.header_media_id = schema.header_media_id;
    responseData.caption = schema.caption;
    delete schema.header_type;
    delete schema.header_media_id;
  }

  if (schema.type == "menu" && !schema.main_menu) {
    const options = [];
    const option = {
      title: schema.menu_title,
    };
    const rows = [];
    for (const opt of schema.items) {
      rows.push({ id: opt.id || "", title: opt.title });
    }
    option.rows = rows;
    options.push(option);
    schema.sections = options;
    schema.type = "interactive";
    delete schema.items;
    delete schema.actions;
    delete schema.action_button;
    responseData.reply_message = schema;
    responseData.type = "reply_message";
  }

  if (schema.type == "form") {
    responseData.flow_text_initial = schema.content;
    responseData.flow_schema = schema.schema;
    responseData.type = "flow";
    responseData.sub_type = "form";
  }

  if (schema.type == "products" || schema.type == "order" || schema.type == "catalog") {
    responseData.flow_products_id = schema.products;
    responseData.flow_text_initial = schema.content;
    responseData.flow_schema = [];

    // type product
    if (schema.type == "products") {
      responseData.sub_type = "products";
      responseData.flow_schema.push({
        id: "product",
        label: "Producto Seleccionado",
        type: "string",
      });
    }

    if (["order", "catalog"].includes(schema.type)) {
      responseData.sub_type = schema.type;
      responseData.flow_schema.push({
        id: "products",
        label: "Productos seleccionados",
        type: "array",
      });
      responseData.header_type = schema.header_type;
      responseData.header_media_id = schema.header_media_id;
      responseData.header_media_name = schema.header_media_name;
      responseData.header_media_url = schema.header_media_url;

      if (schema.type === "catalog") responseData.flow_categories_id = schema.categories;
    }

    responseData.type = "flow";
    delete schema.action_button;
    delete schema.header_type;
    delete schema.header_media_id;
    delete schema.header_media_name;
    delete schema.header_media_url;
  }

  if (schema.type == "text") {
    schema.type = "text";
    responseData.flow_text_initial = schema.content;
    responseData.reply_message = schema;
    responseData.type = "reply_message";
    delete schema.action_button;
  }

  if (schema.type == "file") {
    responseData.type = "reply_message";
    responseData.header_type = schema.header_type;
    responseData.header_media_id = schema.header_media_id;
    responseData.caption = schema.caption;
    schema.type = schema.header_type;
    responseData.reply_message = schema;
    delete schema.header_type;
    delete schema.header_media_id;
    delete schema.action_button;
  }

  if (responseData.type !== "flow") responseData.is_final_message = schema.is_final_message;

  delete schema.schema;
  delete schema.actions;
  delete schema.listTitle;
  delete schema.products;
  delete schema.role;
  delete schema.parent;

  /// flow types
  console.log("before save format", responseData);
  return responseData;
}

export function mockupProductResponse(currentMessage) {
  console.log("p1---->", currentMessage);
  return {
    type: "text",
    role: "user",
    content: "Producto 1",
  };
}
export function mockupProductDetailResponse(currentMessage) {
  console.log("p2---->", currentMessage);
  return {
    type: "text",
    role: "assistant",
    disabled: true,
    content:
      "Claro! aqui tienes el detalle del producto:\n[DETALLE DEL PRODUCTO]\n\nDesea continuar con este producto?",
  };
}
export function mockupFormResponse(currentMessage) {
  console.log("1---->", currentMessage);
  return {
    type: "text",
    role: "user",
    content: "Mis datos son...",
  };
}
export function mockupFormconfirm(currentMessage) {
  console.log("2---->", currentMessage);
  let buttonId = "none";

  if (currentMessage.complete_action?.id) {
    if (currentMessage.complete_action.type === "flow") {
      buttonId = `flow-start-${currentMessage.complete_action.id}`;
    } else {
      buttonId = `srm-${currentMessage.complete_action.id}`;
    }
  }

  return {
    id: currentMessage.id,
    override_type: currentMessage.type,
    type: "actions",
    role: "assistant",
    disabled: true,
    content: "Por favor valida tus datos: \n 1...\n2...\nPara confirmar presione el botón Confirmar",
    actions: [
      {
        id: buttonId,
        title: "Confirmar",
      },
    ],
  };
}
